import React from 'react';

const Fallback = ({ title = 'No encontrado', description = 'El recurso solicitado no existe.' }) => (
  <div style={{ padding: '16px', background: '#fff4f4', border: '1px solid #fecaca', borderRadius: '8px' }}>
    <h3 style={{ marginTop: 0, marginBottom: '8px', color: '#b91c1c' }}>{title}</h3>
    <p style={{ margin: 0, color: '#991b1b' }}>{description}</p>
  </div>
);

export default Fallback;
